import { Question, Serializer, QuestionFactory } from 'survey-core';

export class CorporateStructureOfficeListWidgetModel extends Question {
  constructor(name: string) {
    super(name);
    this.titleLocation = 'hidden';
  }

  public override getType(): string {
    return 'corporate_structure_office_list';
  }
}

export function registerCorporateStructureOfficeListWidget() {
  if (Serializer.findClass('corporate_structure_office_list')) return;
  QuestionFactory.Instance.registerQuestion('corporate_structure_office_list', (name) => {
    return new CorporateStructureOfficeListWidgetModel(name);
  });

  Serializer.addClass(
    'corporate_structure_office_list',
    [],
    function () {
      return new CorporateStructureOfficeListWidgetModel('corporate_structure_office_list');
    },
    'question'
  );
}
